import { render, staticRenderFns } from "./PopDepartamento.vue?vue&type=template&id=39c72619&scoped=true&"
import script from "./PopDepartamento.vue?vue&type=script&lang=js&"
export * from "./PopDepartamento.vue?vue&type=script&lang=js&"
import style0 from "./PopDepartamento.vue?vue&type=style&index=0&id=39c72619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c72619",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextField,VTextarea})
